module.exports = "\r\n\r\n.height-30 {\r\n    height: 30px !important;\r\n  }\r\n\r\n  .font-form {\r\n    color: #75787d;\r\n\t\t\tfont-size: 0.75rem;\r\n\t\t\ttext-transform: uppercase;\r\n\t\t\tletter-spacing: 2px;\r\n\t\t\tfont-weight: 500\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles